<!--讨论帖-->
<template>
  <div class="discuss_container">
    <div class="title">
      <i class="close_text iconfont iconchevron-left" @click="backMe"></i>
      <div class="tab_container">
        <div v-for="(item,index) in tabs" :key="index" :class="['tab_item',selected==item.type?'active':'']"
             @click="changeTab(item.type)">{{item.label}}
        </div>
      </div>
    </div>
    <div class="body">
      <transition name="fade">
        <div class="release_content" v-show="selected=='release'">
          <cube-scroll :data="[releaseList]" :options="options" @pulling-up="onPullingUp">
            <template v-for="(item, index) in releaseList">
              <community-item :community-data="item" :key="index" class="release" :news="true"></community-item>
            </template>
            <w-more-loading v-show="moreLoadingShow"/>
            <!--          <w-no-more v-show="noMoreShow && releaseList.length>0"/>-->
            <w-no-results text="暂时没有发布" v-show="releaseList.length===0"/>
          </cube-scroll>
        </div>
      </transition>
      <transition name="fade">
        <div class="collection_content" v-show="selected=='collection'">
          <cube-scroll :data="[collectionList]" :options="options" @pulling-up="onPullingUp">
            <template v-for="(item, index) in collectionList">
              <community-item :community-data="item" :key="index" class="collection" :collection="true"
                              v-if="item.category=='news'"></community-item>
              <blog-item :key="index" :data="item" v-else></blog-item>
            </template>
            <w-more-loading v-show="moreLoadingShow"/>
            <!--          <w-no-more v-show="noMoreShow && collectionList.length>0"/>-->
            <w-no-results text="暂时没有收藏" v-show="collectionList.length===0"/>
          </cube-scroll>
        </div>
      </transition>
      <transition name="fade">
        <div class="interactive_content" v-show="selected=='interactive'">
          <cube-scroll :data="[interactiveList]" :options="options" @pulling-up="onPullingUp">
            <template v-for="(item, index) in interactiveList">
              <community-item :community-data="item" :key="index" class="interactive" :action="true"
                              v-if="item.category=='news'"></community-item>
              <blog-item :key="index" :data="item" v-else :action="true"></blog-item>
            </template>
            <w-more-loading v-show="moreLoadingShow"/>
            <!--          <w-no-more v-show="noMoreShow && interactiveList.length>0"/>-->
            <w-no-results text="暂时没有互动" v-show="interactiveList.length===0"/>
          </cube-scroll>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState, mapMutations} from 'vuex'
  import communityItem from '../community/components/community-item'
  import blogItem from '../community/components/blog-item'
  import WMoreLoading from '../../components/global/w-more-loading'
  import WNoMore from '../../components/global/w-no-more'
  import WNoResults from './components/discuss-no-result'
  import {envMixin} from '../../assets/js/mixin/global'
  import {addClass, removeClass} from "../../assets/js/dom";

  export default {
    name: "discuss",
    mixins: [envMixin],
    components: {
      blogItem,
      WMoreLoading,
      WNoMore,
      communityItem,
      WNoResults
    },
    data() {
      return {
        selected: 'release',
        tabs: [{
          label: '我的发布',
          type: 'release',
        }, {
          label: '我的收藏',
          type: 'collection',
        }, {
          label: '我的互动',
          type: 'interactive',
        }
        ],
        articleContent: {
          release: {
            pages: 1,
            conList: []
          },
          collection: {
            pages: 1,
            conList: []
          },
          interactive: {
            pages: 1,
            conList: []
          }
        },
        options: {
          pullUpLoad: true
        }, // scroll 事件配置
        topicList: []
      }
    },
    watch: {
      selected(value) {
        if (value == 'release') {
          this.$nextTick(() => {
            let els = document.querySelectorAll('.release .community-item-desc')
            for (let i = 0; i < els.length; i++) {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.release .more-item')[i], 'more-item-show')
            }
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(els[i], 'community-content-clip')
                addClass(document.querySelectorAll('.release .more-item')[i], 'more-item-show')
              } else {
                removeClass(els[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.release .more-item')[i], 'more-item-show')
              }
            }
          })
        } else if (value == 'collection') {
          this.$nextTick(() => {
            let els = document.querySelectorAll('.collection .community-item-desc')
            for (let i = 0; i < els.length; i++) {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.collection .more-item')[i], 'more-item-show')
            }
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(els[i], 'community-content-clip')
                addClass(document.querySelectorAll('.collection .more-item')[i], 'more-item-show')
              } else {
                removeClass(els[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.collection .more-item')[i], 'more-item-show')
              }
            }
          })
        } else if (value == 'interactive') {
          this.$nextTick(() => {
            let els = document.querySelectorAll('.interactive .community-item-desc')
            for (let i = 0; i < els.length; i++) {
              removeClass(els[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.interactive .more-item')[i], 'more-item-show')
            }
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(els[i], 'community-content-clip')
                addClass(document.querySelectorAll('.interactive .more-item')[i], 'more-item-show')
              } else {
                removeClass(els[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.interactive .more-item')[i], 'more-item-show')
              }
            }
          })
        }
      }
    },
    computed: {
      ...mapState('discuss', ['releaseList', 'releaseTotal', 'collectionList', 'collectionTotal', 'interactiveList', 'interactiveTotal']),
      // 加载更多的loading
      moreLoadingShow() {
        return (this.selected === 'release' && (this.releaseList.length < this.releaseTotal)) || (this.selected === 'collection' && (this.collectionList.length < this.collectionTotal)) || (this.selected === 'interactive' && (this.interactiveList.length < this.interactiveTotal))
      },
      // 没有更多的显示状态
      noMoreShow() {
        // console.log()
        return (this.selected === 'release' && (this.releaseList.length === this.releaseTotal)) || (this.selected === 'collection' && (this.collectionList.length === this.collectionTotal)) || (this.selected === 'interactive' && (this.interactiveList.length === this.interactiveTotal))
      }
    },
   async mounted() {
     await this.getTopics({refresh: true})
     await this.getReleaseData({refresh: true, payload: {page: 1}})
     await this.getCollectionData({refresh: true, payload: {page: 1}})
     await this.getInteractivData({refresh: true, payload: {page: 1}})
      // await this.getRecommendNews({ refresh: true, payload: { page: 1 } })
     this.$nextTick(() => {
       let els = document.querySelectorAll('.release .community-item-desc')
       for (let i = 0; i < els.length; i++) {
         removeClass(els[i], 'community-content-clip')
         removeClass(document.querySelectorAll('.release .more-item')[i], 'more-item-show')
       }
       for (let i = 0; i < els.length; i++) {
         if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
           addClass(els[i], 'community-content-clip')
           addClass(document.querySelectorAll('.release .more-item')[i], 'more-item-show')
         } else {
           removeClass(els[i], 'community-content-clip')
           removeClass(document.querySelectorAll('.release .more-item')[i], 'more-item-show')
         }
       }
     })
   },
    methods: {
      ...mapActions('discuss', ['getReleaseData', 'getCollectionData', 'getInteractivData']),
      // 跳转话题聚合页
      toTopicDetail(item) {
        this.$db.ls.set('shareNeed', true)
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/news-group/news-group?url=${process.env.VUE_APP_HOST}/community/topic/${item.id}&title=${item.name}&image=${item.image}`
          })
        } else {
          this.$router.push(`/community/topic/${item.id}`)
        }
      },
      // 切换tab
      changeTab(type) {
        this.selected = type;
      },
      // 返回"我的"信息页
      backMe() {
        this.$router.back();
      },
      // 获取话题列表
      async getTopics({refresh}) {
        let res = await this.$api.bbs.getTopics({
          page: this.articlePage,
          size: 50
        })
        if (res.code === 1000) {
          this.topicList = res.data.topics
        }
      },
      // 上拉加载
      onPullingUp() {
        if (this.selected === 'release' && !this.noMoreShow) {
          this.articleContent.release.pages += 1
          this.getReleaseData({refresh: false, payload: {page: this.articleContent.release.pages}})
        } else if (this.selected === 'collection' && !this.noMoreShow) {
          this.articleContent.collection.pages += 1
          this.getCollectionData({refresh: false, payload: {page: this.articleContent.collection.pages}})
        } else if (this.selected === 'interactive' && !this.noMoreShow) {
          this.articleContent.interactive.pages += 1
          this.getInteractivData({refresh: false, payload: {page: this.articleContent.interactive.pages}})
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .discuss_container {
    width: 100vw;
    height: 100vh;
    background-color: #F9F9F9;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    .title {
      width: 100%;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #F4F4F4;
      background-color: #fff;
      z-index: 999;
      position: fixed;
      left: 0;
      top: 0;

      .close_text {
        font-weight: bold;
        position: absolute;
        left: 10px;
      }

      .iconfont {
        font-size: 26px;
        font-weight: bold;
        //margin-right: 16px;
        &.iconmenu {
          font-weight: 400;
          font-size: 22px;
        }
      }

      .tab_container {
        width: 75%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        transition: all 1s;

        .tab_item {
          width: auto;
          height: 100%;
          line-height: 44px;
          color: #606060;
          position: relative;
        }

        .active {
          font-size: 16px;
          font-weight: bold;
          color: #404040;
        }

        .active:after {
          content: '';
          width: 24px;
          height: 2px;
          position: absolute;
          background-color: #FF4F4C;
          left: calc(50% - 12px);
          bottom: 0;
        }
      }
    }

    .body {
      width: 100%;
      height: 100%;
      padding-top: 44px;

      .release_content {
        width: 100%;
        height: 100%;
      }

      .collection_content {
        width: 100%;
        height: 100%;
      }

      .interactive_content {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
